<template>
  <Transition name="fade">
    <div
      v-if="!isDismissed"
      class="
        bg-vice-teal-50
        border border-vice-teal-300
        rounded-lg
        px-4
        py-3
        mb-0.5
        flex
        items-center
        justify-between
        text-sm
      "
    >
      <div class="flex items-center gap-3">
        <InformationCircleIcon class="w-5 h-5 text-vice-teal-600 flex-shrink-0 mt-0.5" />
        <p class="text-vice-teal-900">
          To highlight your question to the clinician, please use
          <button
            type="button"
            class="font-semibold text-vice-rose-600 hover:underline"
            @click="$emit('mention-click')"
          >
            @clinician
          </button>
        </p>
      </div>
      <button
        @click="dismissHint"
        class="text-vice-teal-600 hover:text-vice-teal-800 flex-shrink-0 ml-2"
        aria-label="Dismiss hint"
      >
        <XIcon class="w-5 h-5" />
      </button>
    </div>
  </Transition>
</template>

<script>
import { InformationCircleIcon, XIcon } from '@heroicons/vue/solid';

const STORAGE_KEY = '_vice:clinician_mention_hint_dismissed';

export default {
  name: 'ClinicianMentionHint',

  components: {
    InformationCircleIcon,
    XIcon,
  },

  emits: ['mention-click'],

  data() {
    return {
      isDismissed: false,
    };
  },

  mounted() {
    // Check if user has previously dismissed this hint
    const dismissed = localStorage.getItem(STORAGE_KEY);
    this.isDismissed = dismissed === 'true';
  },

  methods: {
    dismissHint() {
      this.isDismissed = true;
      localStorage.setItem(STORAGE_KEY, 'true');
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
